<template>
  <div class="autocomplete">
    <!-- 输入框 -->
    <rich-input
      v-model="query"
      type="text"
      class="autocomplete-input"
      @input="handleInput"
      @focus="showDropdown = true"
      @blur="onBlur"
    />

    <!-- 下拉列表 -->
    <transition name="fade-slide">
      <div class="dropdown">
        <div v-if="loading && showDropdown" class="loading">
          <rich-loading></rich-loading>
        </div>
        <ul v-if="showDropdown && !loading && results.length" class="dropdown-ul">
          <li
            v-for="(item, index) in results"
            :key="index"
            class="dropdown-item"
            @mousedown.prevent
            @click="selectItem(item)"
          >
            <slot :item="item">
              {{ item.label }}
            </slot>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import { debounce } from '@/common/utils/util'
export default {
  name: 'AutoComplete',
  props: {
    fetchData: {
      type: Function, // 接收一个远程请求函数 (返回 Promise)
      default: (query, cb) => cb(),
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // 格式至少包括{label: 'xxx', value: 'xxx'}，其中label用于展示列表项的UI
      results: [],
      loading: false,
      showDropdown: false,
      timer: null,
    }
  },
  computed: {
    query: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
        this.$emit('change', val)
      },
    },
  },
  methods: {
    // 输入时触发
    handleInput: debounce(function () {
      this.fetchDataByQuery()
    }, 200),

    // 执行搜索
    async fetchDataByQuery() {
      if (!this.fetchData) return
      this.loading = true
      try {
        this.fetchData(this.query, results => {
          this.loading = false
          this.results = results || []
        })
      } catch (err) {
        console.error('fetch error:', err)
        this.loading = false
        this.results = []
      }
    },

    // 选中某项
    selectItem(item) {
      const query = item.label
      this.query = query
      this.showDropdown = false
      this.$emit('select', item)
    },
    onBlur() {
      // 延迟执行，防止失去焦点后，列表项点击事件不触发
      this.$nextTick(() => {
        this.showDropdown = false
        this.results = []
      })
    },
  },
}
</script>

<style scoped>
.autocomplete {
  position: relative;
}
.autocomplete-input {
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
}
.loading {
  /* position: absolute;
  top: 100%;
  left: 0; */
  height: 200px;
  line-height: 200px;
  padding: 12px;
  font-size: 28px;
  color: #999;
  text-align: center;
}
.dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 560px;
  overflow-y: auto;
  background: #fff;
  margin: 0;
  padding: 0;
  list-style: none;
  z-index: 100;
}
.dropdown-ul {
  border: 1px solid #ddd;
}
.dropdown-item {
  padding: 16px;
  cursor: pointer;
  font-weight: 400;
  line-height: 40px;
  color: #16161a;
  font-size: 28px;
}
.dropdown-item:hover {
  background: #f5f5f5;
}

.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.25s ease;
}
.fade-slide-enter,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
</style>
